import HomeIcon from '../../icons/home.svg';
import ActivityCenterIcon from '../../icons/activity center.svg';
import ProductsIcon from '../../icons/products.svg';
import BookOpenIcon from '../../icons/BookOpen.svg';
import InsuranceTools from '../../icons/insurance tools.svg'
import { getNavLinkPermission } from "../Helpers/CheckAccess";
import { getSessionStorageItem, ADVISOR_OBJECT_KEY } from '../../sessionStorage';
import NotificationsIcon from '../../icons/NotificationsIcon.svg';


var advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
var role = advisorObj && advisorObj.role;

const LAYOUT_NAV_LINKS = [
  {
    text: 'Home',
    link: '/',
    icon: HomeIcon,
    isActive: false,
    isHide: getNavLinkPermission(role, "Home")
  },
  {
    text: 'Notifications',
    link: '/Notifications',
    icon: NotificationsIcon,
    isActive: false,
    isHide: getNavLinkPermission(role, "Activity Center")
  },
  {
    text: 'Activity Center',
    link: '/ActivityCenter',
    icon: ActivityCenterIcon,
    isActive: false,
    isHide: getNavLinkPermission(role, "Activity Center")
  },
  {
    text: 'Products',
    link: '/Products',
    icon: ProductsIcon,
    isActive: false,
    isHide: getNavLinkPermission(role, "Products")
  },
  // {
  //   text: 'Insurance Tools',
  //   link: '/InsuranceTools',
  //   icon: InsuranceTools,
  //   isActive: false,
  //   isHide: getNavLinkPermission(role, "InsuranceTools")
  // },
  {
      text: 'Resource Center',
      link: '/ResourceCenter',
      icon: BookOpenIcon,
      isActive:false,
    isHide: getNavLinkPermission(role, "Resource Center")
  },
];

const LAYOUT_DEFAULT_NAV_LINKS = LAYOUT_NAV_LINKS.filter((links) => !links.isHide);

// may need to take a second look at this
const setDefaultLinks = () => {

  let links = LAYOUT_DEFAULT_NAV_LINKS;
  links.forEach((part, index, array) => { array[index].isActive = false; });

  let currentURL = window.location.href.split('/');

  // remove any query strings
  currentURL = currentURL.map((url) => url.split("?")[0]);

  currentURL.forEach((linkSegment, i) => {
    let activeNavItem = links.find(item => item.link.replace('/', '') === linkSegment);

    if (activeNavItem) {
      activeNavItem.isActive = true;
    }
  });

  let activeItems = links.filter(item => item.isActive === true);

  if (activeItems.length > 1) {
    // remove home active status
    links = links.map(item => item.text === 'Home' ? { ...item, isActive: false } : item);
  }

  return links;
}

export { LAYOUT_DEFAULT_NAV_LINKS, setDefaultLinks }



// WEBPACK FOOTER //
// ./src/components/Layout/LayoutConst.js